<template>
  <div class="logs-list panel list-panel">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span @click="titleClickHandler ? titleClickHandler() : function() {}" :class="{ 'has-toggle' : titleClickHandler }">
          <b class="title">{{ title }}</b>
          <icon name="sliders-h"
                class="toggle-icon"
                v-if="titleClickHandler"></icon>
        </span>
        <div v-if="showTotalTime" class="log-total">
          <icon name="clock" />
          <span>{{ secondsToTime(totalTime) }}</span>
        </div>
      </div>
      <div class="list-group"
           :key="key"
           v-for="(logs, key) in logsGrouped">
        <h2 class="log-date" v-if="groupLogsByDate">{{ key }}</h2>
        <log v-for="log in logs"
             :log="log"
             :key="log.id"
             :show-client-code="showClientCode"
             :show-project-title="showProjectTitle"
             :show-task-title="showTaskTitle"
             :show-task-project-name="showTaskProjectName"
             :show-task-date="showTaskDate"
             :show-comment="showComment"
        ></log>
      </div>
      <div class="list-group"
           v-if="!groupLogsByDate">
        <log v-for="log in logsSorted"
             :log="log"
             :key="log.id"
             :show-client-code="showClientCode"
             :show-project-title="showProjectTitle"
             :show-task-title="showTaskTitle"
             :show-task-project-name="showTaskProjectName"
             :show-task-date="showTaskDate"
             :show-comment="showComment"
        ></log>
      </div>
      <div class="log list-item" v-if="!logsSorted.length">
        <p>No Logs Found!</p>
      </div>
    </el-card>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mixin as LogTimes } from '../../mixins/LogTimes'

  export default {
    name: 'log-list',
    mixins: [LogTimes],
    props: {
      groupLogsByDate: { default: true },
      showClientCode: { default: false },
      showProjectTitle: { default: true },
      showTaskTitle: { default: true },
      showTaskProjectName: { default: false },
      showTaskDate: { default: true },
      showComment: { default: true },
      showTotalTime: { default: false },
      titleClickHandler: { default: false },
      title: { default: 'Logs' },
      logs: null
    },
    data () {
      return {}
    },
    methods: {
      onTitleClick () {
        this.$emit('onTitleClick')
      }
    },
    computed: {
      logsGrouped () {
        // Group Logs into single Days
        let groups = {}
        let thisYear = moment().year()
        if (this.groupLogsByDate) {
          this.logsSorted.map(item => {
            let date = moment.utc(item.end).local()
            let dateFormat = (date.year() !== thisYear) ? 'ddd Do MMM YYYY' : 'ddd Do MMMM'
            let dateFormatted = moment.utc(item.end).local().format(dateFormat)
            // Dimension the array if it does not yet exist
            if (!groups.hasOwnProperty(dateFormatted)) {
              groups[dateFormatted] = []
            }
            groups[dateFormatted].push(item)
          })
        }
        return groups
      },
      logsSorted () {
        return this.logs.slice().sort((a, b) => {
          if (Date.parse(a.end) < Date.parse(b.end)) {
            return 1
          } else if (Date.parse(a.end) > Date.parse(b.end)) {
            return -1
          } else {
            return 0
          }
        }).filter((log) => {
          // Don't show logs that are in progress
          return !!log.end
        })
      },
      totalTime () {
        let total = 0

        if (this.logs) {
          this.logs.map((log) => {
            if (log.end) {
              total += this.logTimeInSeconds(log)
            }
          })
        }

        return total
      },
      // Vuex Mappings
      users () {
        return this.$store.state.users.objects
      },
      projects () {
        return this.$store.state.projects.objects
      },
      tasks () {
        return this.$store.state.tasks.objects
      }
    }
  }
</script>
<style lang="less" rel="stylesheet/less">
  .logs-list {
    .log-date {
      padding: 2px 0 8px 10px;
      font-size: 1.1rem;
    }
    .log-total {
      float: right;
      .fa-icon {
        margin-right: 5px;
      }
      .fa-icon,
      span {
        display: inline-block;
        vertical-align: middle;
      }

    }
    .el-card__body {
      padding: 0;
    }
    .task-list-item:last-child {
      border-bottom: none;
    }
    .title {
      vertical-align: middle;
    }
    .toggle-icon {
      margin-left: 8px;
      vertical-align: middle;
    }
    .has-toggle {
      cursor: pointer;
      padding: 5px 0;
    }
  }
  .log-filter {
    .md-input-container {
      margin: 0;
      padding-top: 0;
      min-height: 0;
      height: 100%;
    &:after {
        display: none;
      }
    }
    .md-select {
      min-width: 0;
      height: 100%;
      color: transparent;
      &:after {
        display: none;
      }
    }
  }
</style>
